<template lang='pug' src='./about-us.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { moveTo } from '@/mixins'

export default {
  computed: {
    props () {
      return this.$store.state.pages['about']
    }
  },
  components: {
    Icon
  },
  mixins: [ moveTo ],
  methods: {
    showContent (i) {
      this.$store.dispatch('VIEW_TYPES', i)
    },
    openOffice () {
      this.$store.dispatch('VIEW_OFFICE', true)
      this.$store.state.showOffice ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
      console.log('click', this.$store.state.showOffice)
    }
  }
}
</script>



// WEBPACK FOOTER //
// about-us.vue?9ba8aa0e